import { render } from "./FeedSeparatorLabel.vue.js?vue&type=template&id=e928062e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedSeparatorLabel.vue?vue&type=template&id=e928062e"
import script from "./FeedSeparatorLabel.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedSeparatorLabel.vue?vue&type=script&lang=js"
export * from "./FeedSeparatorLabel.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedSeparatorLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/FeedSeparatorLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e928062e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e928062e', __exports__)) {
    api.reload('e928062e', __exports__)
  }
  
  module.hot.accept("./FeedSeparatorLabel.vue.js?vue&type=template&id=e928062e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedSeparatorLabel.vue?vue&type=template&id=e928062e", () => {
    api.rerender('e928062e', render)
  })

}


export default __exports__